"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var VideoPlayIcon = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(VideoPlayIcon, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(VideoPlayIcon);

  function VideoPlayIcon() {
    (0, _classCallCheck2["default"])(this, VideoPlayIcon);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(VideoPlayIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/_react["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: "#FFF"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#333F52",
        d: "M13.8553214,9.06258428 L14.948105,14.4662913 C15.0393314,14.9173967 14.7475917,15.3570435 14.2964863,15.4482699 C14.1874645,15.4703172 14.0751321,15.4703161 13.9661107,15.4482667 L8.56267099,14.3554291 C8.11156731,14.264194 7.81983614,13.8245416 7.91107119,13.373438 C7.94356195,13.2127902 8.02270422,13.0652905 8.13859643,12.9493925 L12.4492526,8.63852317 C12.7746814,8.31307821 13.3023189,8.31306516 13.6277639,8.63849402 C13.7436756,8.75440001 13.8228299,8.90191683 13.8553214,9.06258428 Z",
        transform: "rotate(-45 11.45 11.95)"
      })));
    }
  }]);
  return VideoPlayIcon;
}(_react["default"].PureComponent);

var _default = VideoPlayIcon;
exports["default"] = _default;